import Phaser from 'phaser';

const ICONS: readonly string[] = [
  'inbox',
  'message-circle',
  'table',
  'book-open',
  'phone',
  'volume-2',
  'volume-x',
  'pause',
  'x',
  'minus',
  'square',
  'dollar-sign',
  'alert-circle',
  'file-text',
  'clock',
  'trending-down',
  'trending-up',
  'send',
  'mail-x',
  'bell',
  'circle-dollar-sign',
  'settings',
];

export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'BootScene' });
  }

  preload(): void {
    for (const name of ICONS) {
      // Phaser rasterizes at this size by default; we resize per-use site via setScale.
      this.load.svg(`icon:${name}`, `assets/icons/${name}.svg`, { width: 64, height: 64 });
    }
  }

  create(): void {
    this.scene.start('MenuScene');
  }
}
